import { defaultPlayerProfileFields } from "./playerProfileDefaults";

export const PLAYER_SCHEMA_VERSION = 1;

export const PLAYER_DISPLAY_NAME_MIN = 1;
export const PLAYER_DISPLAY_NAME_MAX = 80;

export const PLAYER_SEARCH_KEYWORD_MAX = 24;
export const PLAYER_SEARCH_KEYWORDS_MAX = 12;

/**
 * Client-generated IDs (offline-first). Document ID === playerId.
 * @returns {string}
 */
export function generatePlayerId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `player_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * @param {Partial<PlayerRecord> & { displayName: string; createdBy: string }} input
 * @param {string} playerId
 * @param {import('firebase/firestore').FieldValue} createdAt
 * @param {import('firebase/firestore').FieldValue} updatedAt
 * @returns {Record<string, unknown>}
 */
export function buildNewPlayerDocument(input, playerId, createdAt, updatedAt) {
  return {
    playerId,
    userId: input.userId ?? null,
    displayName: input.displayName.trim(),
    normalizedName: input.normalizedName,
    searchKeywords: input.searchKeywords ?? [],
    isActive: input.isActive !== false,
    isMerged: false,
    mergedIntoPlayerId: input.mergedIntoPlayerId ?? null,
    schemaVersion: PLAYER_SCHEMA_VERSION,
    createdBy: input.createdBy,
    createdAt,
    updatedAt,
    ...defaultPlayerProfileFields(),
  };
}
